import React from 'react';
/**
 * `AppUnderMaintenance` renders a maintenance banner page.
 *
 * It reads an error/message string from router location state and sets the
 * document title using `Helmet`.
 */
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type LocationState = {
  error: string;
};

const AppUnderMaintenance = (): JSX.Element => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { error } = state as LocationState;

  return (
    <>
      <Helmet>
        <title>{t('page-title.under-maintenance')}</title>
      </Helmet>

      <div className='banner'>
        <div className='container'>
          <div className='warningMessage'>
            <p>
              <b>{error}</b>
            </p>
          </div>
        </div>
        <div className='spimage'>
          <svg
            width='250'
            height='150'
            viewBox='0 0 352 185'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='sp-image-svg'>
            <path
              d='M306.778 1.02945C306.778 1.73199 307.247 2.55163 307.949 2.9029C308.652 3.25418 308.769 2.78581 308.417 1.84909C307.598 -0.258551 306.778 -0.609824 306.778 1.02945Z'
              fill='black'></path>
            <path
              d='M96.0145 7.46959C96.0145 7.70377 96.9513 8.6405 98.1222 9.46013C99.8785 10.9823 99.9956 10.8652 98.4734 8.99177C96.9513 7.11832 96.0145 6.53286 96.0145 7.46959Z'
              fill='black'></path>
            <path
              d='M303.265 72.4549C287.107 75.7334 277.974 92.4774 284.062 107.582L285.819 112.149L272.588 131.235C265.328 141.773 257.132 153.599 254.321 157.463C247.296 167.299 244.369 173.973 245.188 178.071L245.891 181.467H122.945C14.4022 181.467 0 181.701 0 183.223C0 184.745 14.7535 184.979 125.404 184.979C244.486 184.979 250.809 184.862 249.872 182.872C249.286 181.818 248.935 178.773 248.935 176.197C248.935 172.216 250.457 169.172 260.176 155.121C266.382 146.105 275.515 132.757 280.433 125.614L289.449 112.383L287.575 107.699C283.828 98.2149 285.702 87.9109 292.493 81.588C295.654 78.5436 304.436 74.5625 305.49 75.6164C305.724 75.8505 303.265 80.5342 299.87 86.1545C296.591 91.6578 293.898 96.5756 293.898 97.044C293.898 97.6294 298.465 100.674 304.085 103.952C310.993 108.051 314.74 109.573 315.677 108.87C316.38 108.168 319.541 103.367 322.585 98.2149C327.269 90.3698 328.44 89.0818 329.377 90.7211C331.484 94.5851 329.728 105.943 326.215 110.978C322.702 116.13 314.272 120.579 308.066 120.579C304.553 120.579 304.202 121.165 288.629 152.194C279.964 169.523 272.822 184.043 272.822 184.394C272.822 184.745 290.502 184.979 312.047 184.979C346.121 184.979 351.273 184.745 351.273 183.223C351.273 181.701 346.355 181.467 314.506 181.467H277.74L291.908 152.779C303.734 128.893 306.544 124.092 308.534 124.092C313.335 124.092 322.117 120.345 325.747 116.715C330.782 111.68 333.709 104.772 333.709 97.7465C333.709 91.892 330.665 83.6956 328.44 83.6956C327.854 83.6956 324.576 88.3793 321.18 94.1167C317.902 99.7371 314.857 104.655 314.506 105.006C313.686 105.826 298.582 97.2782 298.582 95.9902C298.582 95.4047 301.275 90.3698 304.553 84.8665C309.822 75.9676 311.11 71.1669 308.3 71.5182C307.832 71.6353 305.49 71.9865 303.265 72.4549Z'
              fill='black'></path>
            <path
              d='M260.293 165.074C252.097 168.469 255.024 181.467 264.04 181.467C268.489 181.467 272.822 177.134 272.822 172.685C272.822 166.947 265.913 162.732 260.293 165.074ZM268.489 169.875C270.597 172.802 269.777 176.432 266.733 178.071C263.689 179.71 260.527 178.539 259.005 175.144C256.312 169.172 264.742 164.488 268.489 169.875Z'
              fill='black'></path>
          </svg>
        </div>
      </div>
    </>
  );
};

export default AppUnderMaintenance;
